import React from 'react'

import { useShownPrompt } from '@zet/common/api/prompts/hooks'
import {
  BTN_SM,
  Button,
  H5,
  SH2,
  Stack,
  XStack,
  colors,
} from '@zet/design-system'
import { i18n } from '@zet/localization'
import { navigationRef } from '@zet/utils/navigation'
import { LinearGradient } from 'expo-linear-gradient'
import LottieView from 'lottie-react-native'
import { ModalComponentProp } from 'react-native-modalfy'

import LoyaltyZET from '../../../assets/svgs/loyalty-zet.svg'
import { ModalStackParams } from '../modalConfig'

type Props = ModalComponentProp<ModalStackParams, void, 'RewardsModal'>

const RewardsModal = ({ modal: { closeModal, getParam } }: Props) => {
  const { mutate } = useShownPrompt()
  const handlePress = () => {
    closeModal()
    navigationRef.navigate('LoyaltyProgramLevelScreen', {
      showCoachMark: true,
    })
    mutate({
      name: 'LOYALTY_GIFT_DISCOVERY',
      acknowledgeType: 'continue',
    })
  }

  return (
    <>
      <Stack
        className="w-full"
        style={{ paddingRight: 40, marginHorizontal: 30 }}
      >
        <LinearGradient
          colors={[colors.tertiary[150], 'transparent']}
          locations={[0.0, 0.99]}
          start={{ x: 0, y: 0 }}
          end={{ x: 0.0, y: 3.5 }}
        >
          <Stack className="h-full w-full items-center justify-center bg-transparent">
            <LottieView
              autoPlay
              resizeMode="cover"
              className="h-[250] w-[250] self-center"
              source={require('../../../assets/lottie/giftUnlocked.json')}
            />
            <XStack className="bg-tertiary-100 rounded-lg px-3 py-2">
              <LoyaltyZET height={26} width={26} />
              <SH2 className="ml-1 text-center text-white">
                {i18n.t('rewardsModal.yourGiftIsHere')}
              </SH2>
            </XStack>
            <Stack className="py-4">
              <H5 className="py-2 text-center text-white">
                {i18n.t('rewardsModal.yourSalesGeniusRewardIsReady')}
              </H5>
            </Stack>
            <Button
              className={'bg-primary-10 mt-2 items-center justify-center'}
              onPress={handlePress}
            >
              <BTN_SM className="text-primary-100">
                {i18n.t('rewardsModal.claimNow')}
              </BTN_SM>
            </Button>
          </Stack>
        </LinearGradient>
      </Stack>
    </>
  )
}

export default RewardsModal
